import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/portal/catalogue/')({
  beforeLoad: () => {
    throw redirect({ to: '/portal/catalogue/charge-items' });
  },
});
